'use client'

import type { MergedArticle } from '@/feature/product/types/mergedProduct'
import { memo } from 'react'

type ReferencesProductTechnicalSpecsProps = {
  columns: string[]
  additionalTechnicalSpecs: MergedArticle['additionalTechnicalSpecs']
}

function ReferencesProductTechnicalSpecsComponent({
  columns,
  additionalTechnicalSpecs,
}: ReferencesProductTechnicalSpecsProps) {
  return (
    <>
      {columns.map((column) => (
        <td key={column} className="p-2 font-bold">
          {additionalTechnicalSpecs?.find((spec) => spec.label === column)?.value || '-'}
        </td>
      ))}
    </>
  )
}

export const ReferencesProductTechnicalSpecs = memo(ReferencesProductTechnicalSpecsComponent)
